import { render, staticRenderFns } from "./RecoverPassForm.vue?vue&type=template&id=512a75f6&scoped=true"
import script from "./RecoverPassForm.vue?vue&type=script&lang=js"
export * from "./RecoverPassForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverPassForm.vue?vue&type=style&index=0&id=512a75f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a75f6",
  null
  
)

export default component.exports